import { CmsIconListItem, CmsMultiContent } from '@domgen/dgx-fe-cms';

export interface CmsApplianceDetailsModelSerialBenefitsPanel {
  benefits: CmsMultiContent<CmsIconListItem>;
  title: string;
}
